// weight: 1 → 700, 2 → 600, 3 → 400 (как в telegram-ui)
export function Text({ weight = 3, className = "", style, children }) {
  return (
    <span className={`ui-typo ui-text ui-w${weight} ${className}`} style={style}>
      {children}
    </span>
  );
}
